import { Record, List } from 'immutable';
import Name from '@famly/vet_common_name';
import Image from '@famly/vet_common_image';
const Child = Record({
    birthday: '',
    birthplace: '',
    checkedIn: false,
    checkinTime: null,
    checkins: List(),
    id: '',
    childId: '',
    createdTime: '',
    email: null,
    endDate: null,
    extraInfo: '',
    groupId: '',
    hasVacation: false,
    homeAddress: null,
    image: Image.default,
    institutionId: '',
    isAbsent: false,
    isSick: false,
    isSleeping: false,
    language: '',
    leaves: List(),
    leavingReason: '',
    loginId: '',
    name: Name.default,
    nationality: '',
    pickupName: null,
    pickupRelationId: null,
    pickupTime: null,
    statusRegistrations: List(),
    startDate: '',
    statuses: List(),
    lastCheckIn: {},
    goHomeWithChildId: '',
    hasImage: true,
    relations: null,
});
function fromAPI(data) {
    return new Child({
        ...data,
        id: data.childId,
        name: Name.fromAPI(data.name),
        image: Image.fromAPI(data.image),
        statusRegistrations: List(data.statusRegistrations),
        lastCheckIn: data.checkins && data.checkins.length > 0 ? data.checkins[0] : null,
    });
}
const ChildModel = {
    record: Child,
    default: new Child(),
    fromAPI,
};
export default ChildModel;
